import { ComponentProps } from 'lib/ComponentProps';

import ChevronLeftIconSvg from 'public/icons/ChevronLeft.svg';

import styles from './ResourcePrevNextNavigation.module.css';

type PrevNextNavigationProps = ComponentProps & {
	fields: {
		previousResource: {
			text: string;
			url: string;
		};
		nextResource: {
			text: string;
			url: string;
		};
	};
};

export default function ResourcePrevNextNavigation(props: PrevNextNavigationProps): JSX.Element {
	// TO DO - if no previousResource, the back button directs to the overview page

	return (
		<section className={`${styles.prevNextNavigation} padX`}>
			{props.fields?.previousResource?.url && (
				<a href={props.fields.previousResource.url} className={styles.link}>
					<ChevronLeftIconSvg className={styles.chevron}></ChevronLeftIconSvg>
					<span>{props.fields.previousResource.text}</span>
				</a>
			)}
			{props.fields?.nextResource?.url && (
				<a href={props.fields.nextResource.url} className={styles.link}>
					<span>{props.fields.nextResource.text}</span>
					<ChevronLeftIconSvg className={`${styles.chevron} ${styles.nextChevron}`}></ChevronLeftIconSvg>
				</a>
			)}
		</section>
	);
}
